import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService, BreakpointService } from 'services';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'environments/environment';

@Component({
	selector: 'app-navbar-admin',
	template: require('./app-navbar-admin.component.html'),
	styles: [require('./app-navbar-admin.component.scss')],
	host: { class: 'flex flex-shrink-0' },
})
export class AppNavbarAdminComponent implements OnInit, OnDestroy {
	private breakpointSubscription: Subscription;
	private userSectionSubscription: Subscription;
	public switchedFromAdmin$: Observable<boolean>;
	public initials: string;
	public resolutionsAppUrl = environment.resolutionsApp;

	navbarOpen = true;

	constructor(public userService: UserService, public router: Router, private breakpointService: BreakpointService) {}

	ngOnInit(): void {
		//this.userService.user$.subscribe(u => this.initials = u.initials);
		//       this.userSectionSubscription = this.userService.userSection$.subscribe(
		//    (section) => {
		//        this.userSection = section;
		//    }
		//);

		// hiding mobile menu if breakpoint changed and mobile sidebar is open
		this.breakpointSubscription = this.breakpointService.isMoreThan('md').subscribe(mobileState => {
			if (mobileState === true) this.navbarOpen = true;
		});
	}

	ngOnDestroy() {
		if (this.breakpointSubscription) this.breakpointSubscription.unsubscribe();
		if (this.userSectionSubscription) this.userSectionSubscription.unsubscribe();
	}

	toggleNavbar() {
		this.navbarOpen = !this.navbarOpen;
	}
}
